import moment from "moment";
import React, { useState } from "react";
import {
  Button,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Spinner,
} from "reactstrap";
import DataService from "../../src/services/requestApi";
import { Modal } from "antd";
import * as XLSX from "xlsx";

const JsonToXlsxDownload = ({ pageName, subUserId, standard }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [loader, setLoader] = useState(false);

  const removeKeys = (obj, keysToRemove) => {
    const newObj = { ...obj };
    keysToRemove.forEach((key) => delete newObj[key]);
    return newObj;
  };

  const formatDate = (dateString) => moment(dateString).format("LL");

  const showModal = () => {
    if (!loader) setIsModalOpen(!isModalOpen);
  };

  const getFileName = (data) => {
    if (pageName === "SchoolListing") return "SchoolList.xlsx";
    if (pageName === "UserListing") return "UserList.xlsx";

    return `${data[0]?.adminId?.school_name || "School"}_${standard ? data[0]?.class : "All"
      }.xlsx`;
  };

  const handleDateChange = (event) => setSelectedDate(event.target.value);

  const handleDownload = async (type) => {
    setLoader(true);

    let data = [];

    try {
      if (type === "whole") {
        if (pageName === "AdminListing") {
          const res = await DataService.GetAdminByAdminId(
            `adminId=${subUserId}&standard=${standard || ""}`
          );
          if (res?.data?.message === "Success") data = res?.data?.UserData;
        } else {
          const res = await DataService.FindAllUsers();
          if (res?.data?.message === "Success") data = res?.data?.admins;
        }
      } else {
        if (!selectedDate) {
          Modal.error({
            title: "Error",
            content: "Please select a date.",
          });
          setLoader(false);
          return;
        }

        if (pageName === "AdminListing") {
          const res = await DataService.GetAdminByAdminId(
            `adminId=${subUserId}&startDate=${selectedDate}&standard=${standard || ""}`
          );
          if (res?.data?.message === "Success") data = res?.data?.UserData;
        } else {
          const res = await DataService.FindAllUsersByParams(
            `startDate=${selectedDate}`
          );
          if (res?.data?.message === "Success") data = res?.data?.admins;
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (!data || data.length === 0) {
      Modal.error({
        title: "No Data",
        content: "No data available for download.",
      });
      setLoader(false);
      return;
    }
    const keysToRemove =
      pageName === "AdminListing"
        ? [
            "dataName",
            "isReportGenerated",
            "adminId",
            "_id",
            "__v",
            "password",
            "updated_at",
            "created_at",
            "fingerLeftIndex",
            "fingerLeftLittle",
            "fingerLeftMiddle",
            "fingerLeftRing",
            "fingerLeftThumb",
            "fingerRightIndex",
            "fingerRightLittle",
            "fingerRightMiddle",
            "fingerRightRing",
            "fingerRightThumb",
            "isChecked",
            "isComplete",
            "status",
            "personality",
            "dob",
          ]
        : ["role", "status", "_id", "__v", "password", "updated_at"];

    const modifiedData = data.map((item) => ({
      ...removeKeys(item, keysToRemove),
      "Date of Birth": formatDate(item?.dob),
      Primary: item?.userReport?.personality?.primary,
      Secondary: item?.userReport?.personality?.secondary,
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(modifiedData);
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, getFileName(data));

    setSelectedDate("");
    setLoader(false);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={showModal} color="primary" size="sm" className="text-nowrap p-2">
        Download XLSX
      </Button>

      <Modal
        title="Download Excel"
        open={isModalOpen}
        footer={null}
        onCancel={showModal}
        className="jsontoxlsx"
      >
        <Button
          onClick={() => handleDownload("whole")}
          color="dark"
          className="w-100 mb-4 mt-2"
          disabled={loader}
        >
          {loader ? (
            <>
              <Spinner size="sm" /> Please wait...
            </>
          ) : (
            "Download Whole Data"
          )}
        </Button>

        <h3 className="text-dark">Sort by Date</h3>

        <FormGroup className="my-3">
          <InputGroup>
            <InputGroupAddon addonType="prepend">
              <InputGroupText>
                <i className="ni ni-calendar-grid-58 text-dark" />
              </InputGroupText>
            </InputGroupAddon>

            <Input
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              disabled={loader}
            />
          </InputGroup>
        </FormGroup>
        <Button
          onClick={() => handleDownload("date")}
          color="dark"
          className="w-100"
          disabled={loader}
        >
          {loader ? (
            <>
              <Spinner size="sm" /> Please wait...
            </>
          ) : (
            "Download"
          )}
        </Button>
      </Modal>
    </>
  );
};

export default JsonToXlsxDownload;